function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M369.522 9.51961L273.808 1.66203C268.649 1.23846 264.091 4.93725 263.618 9.93147L260.162 46.4306C259.69 51.4152 263.482 55.8092 268.641 56.2328L300.195 58.8231L311.835 72.2788C313.586 74.304 316.718 74.5611 318.823 72.8526L332.812 61.5008L364.375 64.092C369.525 64.5147 374.093 60.8167 374.566 55.8225L378.021 19.3234C378.493 14.3388 374.702 9.94481 369.542 9.52124L369.522 9.51961Z",
  fill: "#FFD417"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M316.101 36.6262L319.071 36.864L319.878 28.5527L319.848 28.5503C319.328 29.293 318.615 29.7782 317.703 30.0538L316.634 25.5915C318.545 25.0666 319.992 23.8849 320.976 22.0464L326.296 22.4723L324.855 37.3269L327.055 37.5031L326.634 41.8461L315.669 40.9684L316.091 36.6254L316.101 36.6262Z",
  fill: "#111927"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M329.356 35.7102L335.306 35.3721C335.098 37.5164 335.591 38.6992 336.698 38.7877C337.607 38.8605 338.204 38.1524 338.342 36.7293C338.493 35.1716 337.941 34.2941 336.677 34.0767L336.02 33.9661L336.278 31.3122L337.054 31.3258C338.109 31.3327 338.704 30.6438 338.836 29.2784C338.959 28.0188 338.613 27.2644 337.842 27.2028C336.982 27.134 336.365 28.0536 336.051 29.9568L330.461 28.5407C331.203 24.8985 334.181 22.5397 338.293 22.8686C342.188 23.1801 344.606 25.67 344.29 28.92C344.085 31.0354 342.856 32.5069 340.915 33.001L340.91 33.0586C343.157 33.9167 344.392 35.8759 344.175 38.1067C343.846 41.4913 340.791 43.5144 336.175 43.1452C331.559 42.776 328.936 39.8336 329.335 35.7279L329.356 35.7102Z",
  fill: "#111927"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M346.39 37.4546L352.392 36.9072C352.187 39.023 352.665 40.1467 353.733 40.2321C354.722 40.3112 355.362 39.4707 355.52 37.8358C355.716 35.8259 355.261 34.7622 354.183 34.676C353.659 34.6341 353.093 35.025 352.724 35.6448L347.992 34.5104L349.662 24.4968L361.358 25.4322L360.954 29.5963L354.161 29.0531L353.684 31.9128C354.287 31.4474 355.414 31.237 356.551 31.3279C359.972 31.6015 361.883 34.2935 361.494 38.2942C361.106 42.2948 357.868 44.9531 353.241 44.583C348.614 44.213 345.981 41.4633 346.37 37.4626L346.39 37.4546Z",
  fill: "#111927"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M303.232 19.6254C300.011 15.9035 294.251 15.4211 290.378 18.5707L288.469 20.1283L286.881 18.2934C283.66 14.5715 277.898 14.0987 274.027 17.2387C270.156 20.3787 269.628 25.9528 272.849 29.6747L274.437 31.5096L286.113 45.0003L300.145 33.619L302.053 32.071C305.925 28.931 306.463 23.3578 303.231 19.635L303.232 19.6254Z",
  fill: "#111927"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M51.028 239.051C31.4222 227.409 19.5991 220.382 16.1712 206.908C12.7466 193.447 19.7706 181.611 31.4288 162.015C43.0743 142.422 50.1015 130.599 63.5624 127.174C77.0233 123.75 88.8591 130.774 108.455 142.432C128.048 154.078 139.887 161.114 143.312 174.575C146.737 188.036 139.713 199.872 128.055 219.468C116.409 239.061 109.372 250.9 95.9114 254.325C82.4505 257.75 70.6147 250.726 51.0184 239.067L51.028 239.051Z",
  fill: "#FF8FE3"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M54.3895 233.396C73.0853 244.508 83.4665 250.678 94.2838 247.926C105.101 245.174 111.281 234.777 122.383 216.097C133.496 197.401 139.666 187.02 136.914 176.203C134.162 165.385 123.765 159.206 105.085 148.103C86.3889 136.991 76.0077 130.821 65.1905 133.573C54.3732 136.325 48.1934 146.722 37.0907 165.402C25.988 184.082 19.805 194.466 22.5571 205.283C25.3091 216.1 35.7064 222.28 54.3862 233.383L54.3895 233.396Z",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M41.8223 188.864L46.9691 187.555L51.8251 198.571L51.8761 198.558L51.2091 186.476L57.1733 184.959L62.3741 195.887L62.4252 195.874L61.4006 183.883L66.5474 182.574L66.9281 200.372L60.734 201.948L55.6073 191.15L55.5562 191.163L56.213 203.098L50.019 204.674L41.8478 188.858L41.8223 188.864Z",
  fill: "#111927"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M68.894 190.938C67.5066 185.485 69.6881 181.286 74.5923 180.038C76.3036 179.603 77.9374 179.717 79.4264 180.386C80.9154 181.054 82.0867 182.184 82.918 183.794L78.4135 185.865C77.7278 184.666 76.6611 184.108 75.6139 184.374C73.9026 184.81 73.2394 186.746 73.9347 189.479C74.63 192.212 76.4264 193.768 78.4953 193.241C80.1811 192.812 81.0543 191.434 80.7467 189.691L76.5705 190.753L75.8166 187.79L84.8076 185.503L87.2737 195.196L83.6595 196.116L82.7347 193.55L82.7092 193.556C82.1203 195.678 80.446 197.328 78.3004 197.873C73.9326 198.985 70.2427 196.293 68.8747 190.916L68.894 190.938Z",
  fill: "#111927"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M84.5802 177.986L91.4128 176.248L97.3044 186.525L97.3555 186.512L97.6707 174.656L104.452 172.93L108.728 189.737L104.143 190.904L101.274 179.627L101.223 179.64L100.708 191.778L96.8126 192.769L90.6102 182.34L90.5592 182.353L93.4282 193.63L88.8433 194.796L84.5674 177.989L84.5802 177.986Z",
  fill: "#111927"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M106.24 172.476L111.336 171.179L115.612 187.986L110.516 189.282L106.24 172.476Z",
  fill: "#111927"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M181.933 352.113C181.929 352.109 181.927 352.105 181.927 352.1C181.398 341.35 186.808 319.787 211.121 315.013C214.589 314.326 218.013 313.983 221.281 313.983C222.608 313.983 223.917 314.038 225.204 314.15C226.341 314.248 227.371 313.431 227.472 312.294L232.857 251.797C232.956 250.686 232.126 249.711 231.015 249.61C223.189 248.903 215.656 247.519 208.568 245.508C207.03 245.072 205.531 246.508 205.686 248.099C205.948 250.791 205.668 253.53 204.795 256.17C204.278 257.72 203.642 259.219 202.877 260.636C202.674 261.012 202.587 261.44 202.623 261.866C203.188 268.557 200.593 275.649 195.422 281.11C192.455 284.24 189.242 286.443 185.847 287.666C185.716 287.713 185.59 287.772 185.47 287.844C180.552 290.776 175.068 292.333 169.529 292.333C163.502 292.333 157.563 290.483 152.367 286.982C144.906 281.947 137.04 272.753 136.538 261.927C136.507 261.271 136.19 260.657 135.649 260.284L118.442 248.426C108.481 241.623 103.363 229.524 105.468 217.602C107.584 205.626 116.558 195.998 128.358 193.05L149.438 187.793C150.453 187.54 151.098 186.548 150.949 185.513C150.676 183.626 150.471 181.708 150.328 179.777C148.511 154.261 157.231 133.886 176.254 119.206C193.826 105.633 219.719 97.5565 253.235 95.1744L263.162 94.4653C263.35 94.4321 263.549 94.4099 263.749 94.3878C264.192 94.3435 264.846 94.277 265.699 94.2216C267.128 94.1219 269.466 94 272.424 94C290.75 94 350.9 99.1298 355.564 165.197C356.329 175.891 355.371 185.882 352.699 194.974C352.43 195.888 352.818 196.873 353.651 197.336L364.692 203.466C366.025 204.207 367.663 203.243 367.663 201.718V181.798C367.663 181.231 367.419 180.694 367.012 180.299C360.211 173.7 355.835 161.668 359.487 149.907C360.963 145.142 363.165 141.803 365.46 139.463C365.954 138.959 366.19 138.249 366.047 137.558L362.633 121.123C361.104 113.777 364.04 105.279 372.594 103.218C373.702 102.952 374.809 102.819 375.873 102.819C380.538 102.819 384.246 105.16 386.937 109.795C387.903 111.458 390.836 111.491 391.869 109.868C395.167 104.686 399.408 103.418 402.763 103.418C403.782 103.418 404.813 103.539 405.854 103.794C413.399 105.6 417.421 112.713 415.859 121.499L413.715 132.367C413.499 133.464 414.228 134.514 415.304 134.818C420.694 136.34 424.879 139.949 427.393 145.353C430.938 152.965 430.583 161.828 426.473 168.498C424.832 171.16 422.72 173.226 420.327 174.572C419.839 174.847 419.462 175.287 419.279 175.817C417.784 180.132 414.931 183.644 410.747 186.292C410.141 186.675 409.754 187.332 409.754 188.049V226.233C409.754 236.726 404.392 246.232 395.395 251.65C390.742 254.453 385.446 255.937 380.083 255.937C375.297 255.937 370.5 254.741 366.223 252.481L365.835 252.27L328.357 231.46C327.679 231.083 326.845 231.135 326.208 231.578C320.65 235.454 314.378 238.714 307.471 241.32C306.618 241.642 306.076 242.49 306.16 243.398L312.273 309.239C312.437 311.015 314.737 311.756 316.069 310.57C320.584 306.554 327.245 303.147 337.549 303.147C339.654 303.147 341.892 303.291 344.197 303.568L345.814 303.756C350.379 304.133 354.246 306.183 356.994 309.695C364.129 318.824 361.935 335.687 359.331 350.778L358.977 352.816L358.094 358.082C358.066 358.246 357.924 358.367 357.757 358.367H357.448C357.43 358.367 357.415 358.382 357.415 358.4C357.415 358.419 357.4 358.434 357.381 358.434H273.48C272.407 358.434 271.526 357.587 271.482 356.515L269.832 315.933L268.181 356.504C268.138 357.576 267.256 358.422 266.183 358.422H184.152C183.086 358.422 182.207 357.586 182.155 356.521L181.939 352.126C181.938 352.121 181.936 352.116 181.933 352.113Z",
  fill: "#FBFBF9"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M380.039 249.262C376.36 249.262 372.682 248.364 369.281 246.569C369.192 246.525 369.103 246.47 369.015 246.425L325.317 222.161C318.359 218.295 315.855 209.531 319.722 202.573C323.589 195.615 332.353 193.111 339.311 196.978L374.266 216.389V172.492C374.266 164.537 380.715 158.089 388.67 158.089C396.625 158.089 403.073 164.537 403.073 172.492V226.205C403.073 234.349 398.907 241.728 391.938 245.927C388.26 248.143 384.16 249.262 380.061 249.262H380.039Z",
  fill: "#FBFBF9",
  stroke: "#111927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M378.997 133.038L379.462 133.282L386.631 137.027L389.168 137.536L393.766 135.874L408.49 144.051L417.454 159.673L404.734 176.492H381.955L371.795 171.185C371.795 171.185 370.876 153.158 371.153 153.158C371.43 153.158 377.557 148.217 377.557 148.217L378.975 133.027L378.997 133.038Z",
  fill: "#FBFBF9"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M413.465 163.772C415.116 173.999 411.006 179.162 404.292 182.164C397.577 185.167 391.029 183.084 388.459 181.522",
  fill: "#FBFBF9"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M413.465 163.772C415.116 173.999 411.006 179.162 404.292 182.164C397.577 185.167 391.029 183.084 388.459 181.522",
  stroke: "#111927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M403.815 141.137C408.38 140.362 417.144 139.198 421.299 148.128C426.074 158.377 420.645 169.689 413.532 169.689C406.419 169.689 405.455 158.587 408.69 153.136",
  fill: "#FBFBF9"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M403.815 141.137C408.38 140.362 417.144 139.198 421.299 148.128C426.074 158.377 420.645 169.689 413.532 169.689C406.419 169.689 405.455 158.587 408.69 153.136",
  stroke: "#111927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M374.577 146.201L369.07 119.743C368.306 116.053 369.181 110.835 374.078 109.661C378.92 108.497 381.313 112.12 383.03 117.649C384.748 123.178 389.157 137.537 389.157 137.537",
  fill: "#FBFBF9"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M374.577 146.201L369.07 119.743C368.306 116.053 369.181 110.835 374.078 109.661C378.92 108.497 381.313 112.12 383.03 117.649C384.748 123.178 389.157 137.537 389.157 137.537",
  stroke: "#111927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M404.558 144.051L409.256 120.308C409.987 116.164 409.145 111.389 404.248 110.226C399.761 109.151 397.013 112.685 395.296 118.214C393.579 123.743 389.169 137.536 389.169 137.536",
  fill: "#FBFBF9"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M404.558 144.051L409.256 120.308C409.987 116.164 409.145 111.389 404.248 110.226C399.761 109.151 397.013 112.685 395.296 118.214C393.579 123.743 389.169 137.536 389.169 137.536",
  stroke: "#111927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M378.012 156.15C381.845 158.975 388.127 161.535 391.329 157.158C394.443 152.915 389.811 142.5 382.477 140.617C376.605 139.11 368.993 141.47 365.769 151.862C362.755 161.59 367.143 176.503 378.123 179.162",
  fill: "#FBFBF9"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M378.012 156.15C381.845 158.975 388.127 161.535 391.329 157.158C394.443 152.915 389.811 142.5 382.477 140.617C376.605 139.11 368.993 141.47 365.769 151.862C362.755 161.59 367.143 176.503 378.123 179.162",
  stroke: "#111927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M356.296 206.418C342.657 206.384 335.455 221.818 345.615 233.44L324.608 221.752L338.17 196.424L356.285 206.418H356.296Z",
  fill: "#111927"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M244.924 330.685C244.924 330.685 235.174 317.035 212.34 321.523C187.245 326.453 188.508 351.758 188.508 351.758H261.665L267.05 219.625H242.332L233.158 322.619",
  fill: "#FBFBF9"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M244.924 330.685C244.924 330.685 235.174 317.035 212.34 321.523C187.245 326.453 188.508 351.758 188.508 351.758H261.665L267.05 219.625H242.332L233.158 322.619",
  stroke: "#111927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M306.771 322.498L297.22 219.625H272.502L277.887 351.747H351.089C351.089 351.747 352.352 326.442 327.257 321.523C304.422 317.035 294.672 330.685 294.672 330.685",
  fill: "#FBFBF9"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M306.771 322.498L297.22 219.625H272.502L277.887 351.747H351.089C351.089 351.747 352.352 326.442 327.257 321.523C304.422 317.035 294.672 330.685 294.672 330.685",
  stroke: "#111927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M239.22 254.846C243.928 247.899 261.611 248.63 265.622 255.854V240.653L241.136 237.484L239.22 254.846Z",
  fill: "#111927"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M273.333 240.686L273.931 255.854C278.851 249.074 293.276 248.054 300.245 252.165L298.384 236.93L273.344 240.686H273.333Z",
  fill: "#111927"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M348.84 144.539L342.901 146.633",
  stroke: "#111927",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M159.026 179.129L153.088 181.223",
  stroke: "#111927",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M351.122 194.784L343.644 193.654",
  stroke: "#111927",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M263.883 101.041L253.645 101.772C190.315 106.282 153.531 131.853 156.899 179.262C160.401 228.532 210.025 246.149 252.083 243.157L276.668 241.373L263.883 101.041Z",
  fill: "#111927"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M273.853 241.617C318.049 238.471 352.34 213.985 348.872 165.634C343.565 90.4381 260.835 101.263 263.882 101.041C219.686 104.188 185.395 128.673 188.863 177.024C192.275 225.375 229.691 244.764 273.887 241.617H273.853Z",
  fill: "#00C16B"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M191.632 119.632L188.607 113.583",
  stroke: "#111927",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M217.913 108.42L214.8 103.057",
  stroke: "#111927",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M264.236 104.199L263.383 96.3765",
  stroke: "#111927",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M237.801 104.209L237.048 97.2183",
  stroke: "#111927",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M298.229 106.171L300.023 98.8472",
  stroke: "#111927",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M169.906 139.188L164.134 134.712",
  stroke: "#111927",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M327.146 112.697L322.869 117.04",
  stroke: "#111927",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M319.324 232.078L315.136 227.746",
  stroke: "#111927",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M273.255 233.042C252.171 234.538 234.067 230.56 220.916 221.53C206.745 211.803 198.834 196.624 197.405 176.393C195.954 156.15 201.638 139.997 214.29 128.363C226.035 117.561 243.396 111.057 264.48 109.561C285.564 108.066 303.657 112.043 316.82 121.073C330.99 130.801 338.901 145.98 340.33 166.211C341.782 186.453 336.098 202.607 323.445 214.24C311.701 225.043 294.339 231.546 273.255 233.042Z",
  stroke: "#111927",
  strokeMiterlimit: 10
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M278.717 228.256H278.695C277.554 228.333 276.579 227.447 276.535 226.306L275.914 208.379C275.892 207.603 276.479 206.95 277.244 206.894H277.31C278.086 206.828 278.762 207.393 278.85 208.157L280.977 226.572C281.066 227.38 280.479 228.1 279.659 228.178C279.338 228.211 279.027 228.233 278.706 228.256H278.717ZM251.816 223.336C251.329 223.104 250.841 222.871 250.354 222.627C249.623 222.262 249.334 221.364 249.722 220.655L258.475 204.313C258.841 203.637 259.672 203.36 260.37 203.703H260.392C261.09 204.047 261.4 204.878 261.09 205.587L253.744 222.605C253.423 223.347 252.548 223.68 251.805 223.336H251.816ZM302.882 218.927L293.087 203.183C292.677 202.529 292.866 201.665 293.497 201.233L293.53 201.211C294.173 200.779 295.037 200.923 295.503 201.532L306.582 216.401C307.07 217.054 306.914 217.974 306.25 218.45C305.806 218.76 305.363 219.071 304.909 219.359C304.233 219.813 303.314 219.614 302.882 218.916V218.927ZM230.123 205.21C229.812 204.767 229.502 204.324 229.203 203.87C228.749 203.194 228.948 202.274 229.646 201.842L245.379 192.037C246.033 191.627 246.897 191.815 247.329 192.447L247.351 192.469C247.783 193.112 247.65 193.976 247.03 194.441L232.172 205.543C231.519 206.03 230.599 205.875 230.123 205.21ZM321.706 198.851L305.363 190.087C304.687 189.721 304.41 188.89 304.754 188.192V188.17C305.097 187.472 305.928 187.162 306.637 187.472L323.656 194.829C324.398 195.15 324.73 196.025 324.387 196.768C324.154 197.255 323.921 197.743 323.678 198.23C323.312 198.961 322.415 199.238 321.706 198.862V198.851ZM220.384 178.631C220.34 178.088 220.295 177.545 220.262 176.991C220.218 176.171 220.849 175.484 221.658 175.462C226.799 175.318 235.064 175.041 240.172 174.819C240.947 174.786 241.612 175.373 241.667 176.16V176.26C241.734 177.035 241.169 177.711 240.404 177.8L221.99 179.949C221.182 180.049 220.461 179.451 220.384 178.642V178.631ZM308.033 172.648V172.714C308.022 172.205 307.989 171.695 307.956 171.185C307.901 170.41 308.454 169.734 309.219 169.645L327.633 167.485C328.442 167.385 329.173 167.983 329.24 168.792C329.262 169.036 329.284 169.324 329.306 169.645C329.384 170.875 328.442 171.928 327.212 171.961L308.033 172.648ZM242.986 160.05L225.957 152.705C225.214 152.383 224.882 151.508 225.214 150.766C225.447 150.278 225.68 149.791 225.924 149.303C226.289 148.572 227.176 148.284 227.896 148.672L244.249 157.414C244.936 157.779 245.202 158.61 244.869 159.308V159.33C244.526 160.028 243.695 160.338 242.986 160.028V160.05ZM302.283 155.009L302.261 154.976C301.829 154.333 301.962 153.469 302.582 153.004L317.429 141.902C318.083 141.415 319.002 141.559 319.479 142.224C319.789 142.667 320.099 143.11 320.398 143.564C320.852 144.24 320.653 145.16 319.966 145.592L304.244 155.419C303.591 155.829 302.726 155.652 302.294 155.009H302.283ZM254.11 145.968L243.008 131.122C242.521 130.468 242.665 129.549 243.34 129.072C243.784 128.762 244.227 128.452 244.681 128.153C245.357 127.698 246.277 127.898 246.709 128.596L256.525 144.329C256.935 144.982 256.747 145.847 256.115 146.279L256.093 146.301C255.45 146.733 254.586 146.6 254.121 145.98L254.11 145.968ZM289.221 143.786H289.187C288.489 143.442 288.179 142.611 288.489 141.902L295.824 124.873C296.145 124.12 297.02 123.787 297.763 124.131C298.25 124.352 298.738 124.596 299.225 124.829C299.957 125.194 300.245 126.081 299.857 126.801L291.115 143.154C290.75 143.841 289.919 144.107 289.221 143.775V143.786ZM272.28 140.606C271.516 140.661 270.829 140.107 270.74 139.332L268.591 120.918C268.502 120.109 269.089 119.389 269.887 119.311C270.507 119.256 271.128 119.212 271.748 119.178C272.535 119.134 273.211 119.732 273.266 120.519L274.518 138.789C274.585 139.697 273.898 140.495 272.989 140.551C272.779 140.562 272.535 140.584 272.269 140.606H272.28Z",
  fill: "#027A48"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M278.585 208.8C271.782 209.287 264.846 208.102 257.944 205.299C253.401 203.449 251.23 198.263 253.08 193.732C254.93 189.189 260.115 187.018 264.647 188.868C269.323 190.774 273.732 191.494 278.075 191.04C281.931 190.641 285.687 189.355 289.543 187.095C293.775 184.625 299.215 186.043 301.686 190.275C304.156 194.507 302.738 199.947 298.506 202.418C292.501 205.93 286.23 208.047 279.892 208.689C279.46 208.733 279.017 208.767 278.585 208.8Z",
  fill: "#FBFBF9",
  stroke: "#111927",
  strokeMiterlimit: 10
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M294.03 194.751C289.099 197.632 285.033 199.427 278.995 199.859C272.269 200.335 267.306 199.526 261.301 197.078",
  stroke: "#111927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M294.638 182.974C290.528 182.974 286.55 181.489 283.437 178.786C279.98 175.794 277.908 171.628 277.576 167.075C277.255 162.521 278.717 158.1 281.72 154.655C284.966 150.91 289.686 148.749 294.649 148.749C298.76 148.749 302.737 150.234 305.851 152.937C309.307 155.929 311.379 160.095 311.712 164.648C312.033 169.202 310.57 173.623 307.568 177.068C304.322 180.813 299.602 182.974 294.638 182.974Z",
  fill: "#111927"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M294.65 149.303C298.494 149.303 302.361 150.633 305.485 153.347C312.388 159.341 313.141 169.789 307.147 176.703C303.879 180.481 299.27 182.409 294.627 182.409C290.783 182.409 286.916 181.079 283.792 178.365C276.889 172.371 276.136 161.923 282.13 155.009C285.398 151.231 290.007 149.303 294.65 149.303ZM294.65 148.195C289.52 148.195 284.656 150.411 281.299 154.289C274.917 161.646 275.715 172.825 283.072 179.207C286.285 181.988 290.395 183.528 294.639 183.528C299.768 183.528 304.632 181.312 307.989 177.434C314.371 170.077 313.573 158.898 306.217 152.516C303.004 149.735 298.893 148.195 294.65 148.195Z",
  fill: "#111927"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M280.89 161.38C279.05 160.527 276.979 160.106 274.818 160.261C272.658 160.416 270.663 161.125 268.957 162.233",
  stroke: "#111927",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M308.809 157.303C306.981 158.654 305.286 159.097 303.834 159.485C302.183 159.928 301.208 160.183 299.846 161.757C298.483 163.319 298.361 164.338 298.162 166.033C297.918 168.116 297.608 170.72 294.938 173.789C292.267 176.869 289.63 177.567 287.714 178.077C286.573 178.376 285.742 178.608 284.877 179.24C284.523 178.996 284.19 178.719 283.847 178.42C282.484 177.235 281.365 175.883 280.501 174.431C282.562 172.703 284.534 172.193 286.052 171.783C287.692 171.351 288.667 171.085 290.029 169.523C291.392 167.95 291.514 166.942 291.713 165.247C291.957 163.164 292.267 160.56 294.938 157.491C297.608 154.4 300.134 153.735 302.161 153.192C303.014 152.982 303.679 152.793 304.322 152.461C304.732 152.749 305.142 153.081 305.529 153.414C306.859 154.566 307.956 155.873 308.82 157.292L308.809 157.303Z",
  fill: "#FBFBF9"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M255.217 185.776C251.107 185.776 247.129 184.292 244.016 181.588C240.559 178.597 238.487 174.431 238.155 169.877C237.834 165.324 239.296 160.903 242.299 157.457C245.545 153.701 250.265 151.552 255.228 151.552C259.339 151.552 263.316 153.037 266.43 155.74C273.554 161.922 274.329 172.747 268.147 179.871C264.901 183.616 260.181 185.776 255.217 185.776Z",
  fill: "#111927"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M255.229 152.106C259.073 152.106 262.94 153.436 266.064 156.15C272.967 162.144 273.72 172.592 267.726 179.506C264.458 183.284 259.849 185.211 255.207 185.211C251.362 185.211 247.495 183.882 244.371 181.167C237.468 175.173 236.715 164.726 242.709 157.812C245.977 154.034 250.586 152.106 255.229 152.106ZM255.229 150.998C250.099 150.998 245.235 153.214 241.878 157.092C235.496 164.449 236.294 175.628 243.651 182.009C246.864 184.79 250.974 186.33 255.218 186.33C260.347 186.33 265.211 184.115 268.568 180.237C274.95 172.88 274.152 161.701 266.796 155.319C263.583 152.538 259.472 150.998 255.229 150.998Z",
  fill: "#111927"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M269.388 160.105C267.56 161.457 265.865 161.9 264.413 162.288C262.763 162.731 261.788 162.986 260.425 164.559C259.062 166.122 258.94 167.141 258.741 168.836C258.497 170.919 258.187 173.523 255.517 176.592C252.846 179.672 250.21 180.37 248.293 180.879C247.152 181.179 246.321 181.411 245.456 182.043C245.102 181.799 244.77 181.522 244.426 181.223C243.063 180.037 241.944 178.686 241.08 177.234C243.141 175.506 245.113 174.996 246.631 174.586C248.271 174.154 249.246 173.888 250.608 172.326C251.971 170.753 252.093 169.745 252.292 168.049C252.536 165.967 252.846 163.363 255.517 160.294C258.187 157.203 260.713 156.538 262.74 155.995C263.594 155.784 264.258 155.596 264.901 155.264C265.311 155.552 265.721 155.884 266.109 156.217C267.438 157.369 268.535 158.676 269.399 160.094L269.388 160.105Z",
  fill: "#FBFBF9"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M261.944 151.585C261.866 151.585 261.789 151.585 261.722 151.596L245.901 152.161C242.4 152.283 239.464 149.558 239.342 146.057C239.22 142.556 241.957 139.597 245.447 139.498L261.268 138.933C264.769 138.811 267.705 141.536 267.827 145.037C267.949 148.461 265.334 151.353 261.944 151.585Z",
  fill: "#FBFBF9",
  stroke: "#111927",
  strokeMiterlimit: 10
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M286.618 149.835C286.695 149.835 286.773 149.824 286.84 149.813L302.583 148.14C306.062 147.774 308.589 144.65 308.212 141.16C307.835 137.681 304.711 135.144 301.232 135.531L285.488 137.204C282.009 137.57 279.483 140.694 279.859 144.184C280.225 147.586 283.217 150.079 286.607 149.835H286.618Z",
  fill: "#FBFBF9",
  stroke: "#111927",
  strokeMiterlimit: 10
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M311.79 330.984C311.79 330.984 314.593 306.632 345.15 310.332L311.79 330.984Z",
  fill: "#FBFBF9"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M311.79 330.984C311.79 330.984 314.593 306.632 345.15 310.332",
  stroke: "#111927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M344.242 310.288C360.429 310.288 354.379 339.804 352.374 351.67H315.679C315.679 351.67 322.038 310.288 344.242 310.288Z",
  fill: "#111927",
  stroke: "#111927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M170.482 258.148C170.482 258.148 170.427 258.225 170.393 258.27C165.784 264.962 156.611 266.646 149.919 262.037L122.164 242.902C114.309 237.562 110.309 228.078 111.949 218.716C113.6 209.332 120.647 201.764 129.898 199.46L167.745 190.02C175.634 188.048 183.622 192.845 185.594 200.734C187.567 208.623 182.769 216.611 174.881 218.583L148.367 225.197L166.626 237.784C173.274 242.371 174.991 251.456 170.471 258.137L170.482 258.148Z",
  fill: "#FBFBF9",
  stroke: "#111927",
  strokeWidth: 1.05,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M144.324 254.436C139.194 267.709 151.536 278.401 156.035 281.437C168.045 289.536 182.914 285.481 191.013 273.482C199.112 261.472 195.954 245.174 183.944 237.075C179.08 233.795 173.518 232.355 168.078 232.61",
  fill: "#FBFBF9"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M144.324 254.436C139.194 267.709 151.536 278.401 156.035 281.437C168.045 289.536 182.914 285.481 191.013 273.482C199.112 261.472 195.954 245.174 183.944 237.075C179.08 233.795 173.518 232.355 168.078 232.61",
  stroke: "#111927",
  strokeWidth: 1.05,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M166.394 277.271C175.479 283.398 183.002 284.473 190.536 276.518C195.444 271.332 196.862 264.829 195.488 259.865",
  fill: "#FBFBF9"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M166.394 277.271C175.479 283.398 183.002 284.473 190.536 276.518C195.444 271.332 196.862 264.829 195.488 259.865",
  stroke: "#111927",
  strokeWidth: 1.05,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M187.789 242.88C187.124 233.197 180.233 227.968 172.721 227.79C165.663 227.624 157.232 233.23 157.431 242.393",
  fill: "#FBFBF9"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M187.789 242.88C187.124 233.197 180.233 227.968 172.721 227.79C165.663 227.624 157.232 233.23 157.431 242.393",
  stroke: "#111927",
  strokeWidth: 1.05,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M174.703 265.826C185.107 269.26 194.99 264.463 198.413 254.059C199.909 249.517 199.034 243.246 193.416 238.526C187.744 233.762 177.274 235.202 175.401 240.886C173.374 247.068 180.586 251.522 184.187 252.22",
  fill: "#FBFBF9"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M174.703 265.826C185.107 269.26 194.99 264.463 198.413 254.059C199.909 249.517 199.034 243.246 193.416 238.526C187.744 233.762 177.274 235.202 175.401 240.886C173.374 247.068 180.586 251.522 184.187 252.22",
  stroke: "#111927",
  strokeWidth: 1.05,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M158.494 192.336C164.045 191.006 173.142 197.521 174.56 204.711C175.922 211.603 170.272 219.78 162.871 221.597L176.853 218.162C184.132 216.378 188.897 209.398 187.91 201.964C186.769 193.333 178.404 187.583 169.94 189.61C166.472 190.441 162.616 191.361 158.483 192.347L158.494 192.336Z",
  fill: "#111927"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M430.878 344.532C409.311 348.097 388.86 333.453 385.294 311.878C381.737 290.361 396.338 269.917 417.855 266.309C439.514 262.728 459.965 277.372 463.532 298.947C467.088 320.463 452.487 340.908 430.971 344.516L430.878 344.532Z",
  fill: "#FFD417"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M430.023 338.867C448.499 335.769 460.965 318.278 457.867 299.802C454.768 281.325 437.278 268.859 418.801 271.958C400.325 275.057 387.859 292.547 390.957 311.023C394.056 329.5 411.546 341.966 430.023 338.867Z",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M394.932 288.616C413.904 295.888 431.231 293.043 446.912 280.02",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M401.956 331.066C417.581 318.07 434.903 315.191 453.937 322.47",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M390.945 310.947L457.88 299.878",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M412.628 273.6C408.548 297.082 411.971 319.045 423.501 339.363",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M425.077 271.538C436.499 292.455 440.327 314.35 435.95 337.301",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

function SvgKiwiGlassesTwoFingers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 359,
    viewBox: "0 0 471 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiwiGlassesTwoFingers);
export default __webpack_public_path__ + "static/media/kiwi-glasses-two-fingers.5e43250c.svg";
export { ForwardRef as ReactComponent };